import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { EmpresaService } from '../../services/Empresa/Empresa.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  public version = environment.version;
  empresaId: any;
  empresaNombre: string;

  constructor(private empresaService: EmpresaService) {}
  
  ngOnInit() {
    this.empresaService.empresaId$.subscribe((id: number) => {
      this.empresaId = id;
      this.empresaNombre = this.empresaService.getEmpresaNombre(id);
    });
  }
}
